import React from 'react'
import Footer from '../components/Footer/Footer';
import './styles.css';

import dataentryimg from '../assets/dataentry.png';

import ScrollToTop from '../components/ScrollToTop';
import PageNav from '../components/PageNav/PageNav';

const DataEntry = () => {
    return (
        <div>
            <ScrollToTop />
            <PageNav />
            <section className="main-section">
              <div className="page-container">
                  <div className="page-title">
                    <h1>Administrative Data Entry</h1>
                  </div>    
                          
                  <div className="des-title-text">
                      <span>At WebHarvester Agency, we are expert in providing meticulous and reliable administrative data entry services tailored to meet your business needs. With our expertise in Microsoft Excel, Word, PowerPoint, and a wide range of administrative tasks, we're here to help you streamline your operations and save valuable time.</span>
                    </div>
    
                <div className="page-content">
                  <div className="page-image dataentry">
                    <img src={dataentryimg} alt="" loading='lazy' />
                  </div>
                  
                  <div className="page-description">
                    <div className="des-middle-text">
                      <h3>Our Services Include:</h3>
                      <div className="break-middle">
                        <span className="bold">📊 Microsoft Office Expertise: </span><span>Whether it's creating complex spreadsheets in Excel, crafting professional documents in Word, or designing impactful presentations in PowerPoint, we have the proficiency to handle all your office software needs.</span>                  
                      </div>
    
                      <div className="break-middle">
                        <span className="bold">📋 Copy-Paste Tasks: </span><span>We ensure accurate and efficient copy-paste work for data transfer, content migration, and more.</span>                
                      </div>
    
                      <div className="break-middle">
                        <span className="bold">🔍 Online Research: </span><span>Our skilled team conducts comprehensive online research, gathering valuable information to support your decision-making process, market analysis, and business development.</span>           
                      </div>

                      <div className="break-middle">
                        <span className="bold">📝 Form Filling: </span><span>We handle form filling tasks with precision, ensuring that all required fields are accurately completed, saving you time and effort.</span>           
                      </div>
                    </div>
    
                    <div className="des-middle-text">
                      <h3>Why Choose WebHarvester Agency:</h3>
    
                      <div className="break-middle">
                        <span className="bold">🎯 Accuracy and Quality: </span><span>We prioritize accuracy in every task we undertake, ensuring that your data and documents are error-free and of the highest quality.</span>           
                      </div>
    
                      <div className="break-middle">
                        <span className="bold">⏱️ Timely Delivery:  </span><span>We understand the importance of deadlines. Rest assured, your projects will be completed promptly.</span>           
                      </div>
    
                      <div className="break-middle">
                        <span className="bold">🛠️ Customized Solutions:  </span><span>Our services are tailored to your specific requirements, guaranteeing that you get exactly what you need.</span>           
                      </div>
    
                      <div className="break-middle">
                        <span className="bold">🔒 Data Security: </span><span> Your data's security is our top priority. We adhere to stringent security protocols to protect your sensitive information.</span>           
                      </div>
                    </div>
                  </div>
                </div>
                    <div className="des-title-text">
                      <span>When you partner with WebHarvester Agency for your administrative data entry needs, you're choosing a trusted partner dedicated to efficiency, accuracy, and exceptional service. Let us handle the administrative workload, allowing you to focus on what matters most – growing your business.</span>
                    </div>
    
                    <div className="main-btn">
                      <a href="https://www.fiverr.com/s/ZqjDX8" target='blank'>Order Now</a>
                    </div>
              </div>
            </section>
            <Footer />
        </div>
      )
}

export default DataEntry;